<template>
    <div class="container">
        <div class="p_title" @click="openApp">
            返回应用
        </div>
    </div>
</template>


<script>
export default ({
    created() {

    },

    methods: {
        openApp() {
            window.location.href = "miqu://main/entrance";
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.p_title {
    width: 80vw;
    height: 16vw;
    line-height: 16vw;
    margin-top: 40vw;
    background-color: #1AAD19;
    text-align: center;
    border-radius: 10px;
    font-size: 20px;
    color: white;
    align-self: center;
    justify-content: center;
}

.img {
    width: 40%;
    margin-top: 160px;
    margin-left: 30%;
}
</style>